import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import LaundryProductListTable from './Componate/LaundryProductListTable'

const LaundryProductList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Laundry Items List</HeadingOne>
                    <AddItemBtn url="add-laundry-product" title="Create" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <LaundryProductListTable />
            </div>
        </PageBody>
    )
}

export default LaundryProductList
